module.exports = __webpack_public_path__ + "static/media/travel.192f1692.svg";